// extracted by mini-css-extract-plugin
export var list = "styles-module__list___alDDi";
export var item = "styles-module__item___fIDRc";
export var bullet = "styles-module__bullet___NLzb_";